import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";
import Svg from "@natera/material/lib/svg";

import PortalPhoneImage from "@assets/images/gis_entry_portal_phone.png";
import ArrowIcon from "@assets/svg/icons/arrow.svg";

import "./patientPortalCtaBanner.scss";

const messages = defineMessages({
  heading: {
    id: "patientPortalCtaBanner.heading",
    defaultMessage: "Natera's Patient Portal",
  },
  body: {
    id: "patientPortalCtaBanner.body",
    defaultMessage:
      "Quick, simple sign-up. Manage results, appointments, and bills in one place.",
  },
});

interface Props {
  onClick: () => void;
  dataTestId?: string;
}

// Reuses the GIS public-entry hero (image + copy) as a clickable card that
// ports a guest into tokenized sign-up. Presentational only — the parent owns
// the click behavior (analytics + navigation with token + `si`).
const PatientPortalCtaBanner: FC<Props> = ({
  onClick,
  dataTestId = "create-account",
}) => {
  const intl = useIntl();

  return (
    <button
      type="button"
      className="patient-portal-cta"
      onClick={onClick}
      aria-label={intl.formatMessage(messages.heading)}
      data-testid={dataTestId}
    >
      <img
        className="patient-portal-cta__image"
        src={PortalPhoneImage}
        alt=""
        aria-hidden
      />
      <div className="patient-portal-cta__shade" aria-hidden />
      <div className="patient-portal-cta__content">
        <div className="patient-portal-cta__text">
          <span className="patient-portal-cta__heading">
            {intl.formatMessage(messages.heading)}
          </span>
          <span className="patient-portal-cta__body">
            {intl.formatMessage(messages.body)}
          </span>
        </div>
        <span className="patient-portal-cta__arrow" aria-hidden>
          <Svg content={ArrowIcon} />
        </span>
      </div>
    </button>
  );
};

export default PatientPortalCtaBanner;
